import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_HOUSEHOLD_GET_DEPOSIT_FEES } from 'api/actionTypes';

export default async function getHouseholdDepositFees(
  { state, apiClient },
  { householdId, listingId },
) {
  typeCheck('householdId::PositiveNumber', householdId);
  typeCheck('listingId::PositiveNumber', listingId);
  await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_DEPOSIT_FEES,
    queryId: `${householdId}-${listingId}`,
    state: state,
    payload: {
      householdId,
      listingId,
    },
    onSuccess(householdDepositFees) {
      state.set(['household', 'depositFeesByListingId', listingId], householdDepositFees);
    },
  });
}
